import React from 'react';

import Lozenge from '@atlaskit/lozenge';

import { Table } from '@qality/common-components/src/atoms/Table';
import { ExecutionStatus } from '@qality/common-model';
import { StringUtils } from '@qality/common-utils';

import { useTestCaseExecutionStatusPageContext } from '../../TestCaseExecutionStatusPageProvider';
import Color from '../Color';
import {
  StaticCellPaddingStyled,
  TableCellWrapperStyled,
} from './TestCaseExecutionStatusRow.styled';

type Props = {
  status: ExecutionStatus;
};

export default function TestCaseExecutionStatusRow({
  status,
}: Props): JSX.Element {
  const { defaultStatus } = useTestCaseExecutionStatusPageContext();
  return (
    <Table.Tr key={status.id}>
      <Table.Td>
        <StaticCellPaddingStyled>
          <TableCellWrapperStyled>{status.name}</TableCellWrapperStyled>
        </StaticCellPaddingStyled>
      </Table.Td>
      <Table.Td>
        <StaticCellPaddingStyled>
          <Color status={status} />
        </StaticCellPaddingStyled>
      </Table.Td>
      <Table.Td>
        <StaticCellPaddingStyled>
          {status.category && status.category !== 'NONE' && (
            <Lozenge>{StringUtils.capitalize(status.category)}</Lozenge>
          )}
        </StaticCellPaddingStyled>
      </Table.Td>
      <Table.Td>
        <StaticCellPaddingStyled>
          {status.id === defaultStatus.id && <Lozenge>default</Lozenge>}
        </StaticCellPaddingStyled>
      </Table.Td>
    </Table.Tr>
  );
}
